export const SET_DRAWER_VISIBLE = 'SET_DRAWER_VISIBLE';

export const setDrawerVisible = (visible) => ({
  type: SET_DRAWER_VISIBLE,
  payload: {
    visible,
  },
});
